var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "jade-modal",
    {
      attrs: {
        open: "",
        title: _vm.$t("title", {
          acquirer: _vm.$t(_vm.acquirer.payment_method),
        }),
      },
      on: {
        onClose: function ($event) {
          return _vm.$emit("close")
        },
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function () {
            return [
              _c(
                "jade-button-group",
                [
                  _c(
                    "jade-button",
                    {
                      attrs: { variant: "primary-solid", loading: _vm.loading },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("confirm")
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("general.continue")) + " ")]
                  ),
                  _c(
                    "jade-button",
                    {
                      attrs: { variant: "neutral-subtle" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("close")
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("general.cancel")) + " ")]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        { staticClass: "flex flex-col gap-3" },
        [
          _c("jade-text", { attrs: { variant: "regular", color: "medium" } }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("description", {
                    acquirer: _vm.$t(_vm.acquirer.payment_method),
                  })
                ) +
                " "
            ),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }